/**
 * Infinite Scroll / Load More functionality
 * Handles AJAX loading of additional products in collection pages
 */

(function() {
  function initInfiniteScroll() {
    const loadMoreButton = document.querySelector('.load-more-button');
    if (!loadMoreButton) return;

    const productList = document.querySelector('.infinite-scroll-container');
    const loadMoreText = loadMoreButton.querySelector('.load-more-text');
    const loadMoreSpinner = loadMoreButton.querySelector('.load-more-spinner');
    const statusText = document.querySelector('.load-more-status');
    const productsRangeDisplay = document.querySelector('.products-range');
    const backToTopButton = document.querySelector('.back-to-top-button');
    
    if (!productList) return;
    
    // Back to top button click handler
    if (backToTopButton) {
      backToTopButton.addEventListener('click', () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    }

    let isLoading = false;
    let currentPage = parseInt(loadMoreButton.getAttribute('data-current-page'));
    const totalPages = parseInt(loadMoreButton.getAttribute('data-total-pages'));
    const totalProducts = parseInt(productList.getAttribute('data-total-products'));
    const productsPerPage = parseInt(productList.getAttribute('data-products-per-page'));
    const viewMoreTextTemplate = loadMoreButton.getAttribute('data-view-more-text');
    const noMoreText = loadMoreButton.getAttribute('data-no-more-text');
    const errorText = loadMoreButton.getAttribute('data-error-text');

    // Function to update the product count display
    function updateProductCount() {
      const currentCount = Math.min(productList.children.length, totalProducts);
      if (productsRangeDisplay) {
        productsRangeDisplay.textContent = `1 - ${currentCount}`;
      }

      // Update button text to show how many more will be loaded
      const remainingProducts = totalProducts - currentCount;
      const nextBatchSize = Math.min(productsPerPage, remainingProducts);
      if (nextBatchSize > 0 && loadMoreText) {
        loadMoreText.textContent = viewMoreTextTemplate.replace('{count}', nextBatchSize);
      }
    }

    loadMoreButton.addEventListener('click', async function() {
      if (isLoading) return;

      isLoading = true;
      loadMoreButton.disabled = true;
      if (loadMoreText) loadMoreText.style.display = 'none';
      if (loadMoreSpinner) loadMoreSpinner.style.display = 'inline-block';

      const nextUrl = this.getAttribute('data-next-url');

      try {
        // Fetch the next page
        const response = await fetch(nextUrl);
        if (!response.ok) throw new Error('Network response was not ok');

        const html = await response.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');

        // Extract new product cards
        const newProducts = doc.querySelectorAll('.infinite-scroll-container > *');

        if (newProducts.length > 0) {
          // Collect new product cards for animation
          const newProductCards = [];

          // Append new products to the grid
          newProducts.forEach(product => {
            const clonedProduct = product.cloneNode(true);

            // Remove reveal-on-scroll IMMEDIATELY to prevent CSS opacity: 0 from applying
            clonedProduct.removeAttribute('reveal-on-scroll');
            
            // Set initial state for animation
            clonedProduct.style.opacity = '0';
            clonedProduct.style.transform = 'translateY(20px)';

            productList.appendChild(clonedProduct);
            newProductCards.push(clonedProduct);
          });

          // Trigger any custom element upgrades and initialization
          if (window.customElements) {
            productList.querySelectorAll(':not(:defined)').forEach(el => {
              window.customElements.upgrade(el);
            });
          }

          // Animate in the new products with stagger effect (same as theme)
          requestAnimationFrame(() => {
            newProductCards.forEach((card, index) => {
              setTimeout(() => {
                card.style.transition = 'opacity 0.2s ease-in-out, transform 0.2s ease-in-out';
                card.style.opacity = '1';
                card.style.transform = 'translateY(0)';
              }, 400 + (index * 50)); // 0.4s start delay + 0.05s stagger (matches theme)
            });
          });

          // Dispatch event to notify other scripts about new content
          document.dispatchEvent(new CustomEvent('theme:product-grid:updated', {
            detail: { container: productList }
          }));

          // Update current page
          currentPage++;
          this.setAttribute('data-current-page', currentPage);

          // Check if there are more pages
          if (currentPage >= totalPages) {
            // No more pages - hide button and show back to top
            loadMoreButton.style.display = 'none';
            if (statusText) statusText.textContent = noMoreText;
            if (backToTopButton) backToTopButton.style.display = 'block';
          } else {
            // Update next URL for the next load
            const newNextUrl = nextUrl.replace(/page=\d+/, 'page=' + (currentPage + 1));
            this.setAttribute('data-next-url', newNextUrl);

            // Show button again
            if (loadMoreText) loadMoreText.style.display = 'inline';
            if (loadMoreSpinner) loadMoreSpinner.style.display = 'none';
            loadMoreButton.disabled = false;

            // Update product count display
            updateProductCount();
          }
        } else {
          throw new Error('No products found');
        }

      } catch (error) {
        console.error('Error loading more products:', error);
        if (statusText) {
          statusText.textContent = errorText;
          statusText.style.color = 'red';
        }

        // Re-enable button
        if (loadMoreText) loadMoreText.style.display = 'inline';
        if (loadMoreSpinner) loadMoreSpinner.style.display = 'none';
        loadMoreButton.disabled = false;
      }

      isLoading = false;
    });
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initInfiniteScroll);
  } else {
    initInfiniteScroll();
  }

  // Also listen for Shopify section reload events (for theme editor)
  document.addEventListener('shopify:section:load', initInfiniteScroll);
})();
